"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueWrapper = exports.ListCellWrapper = exports.CellWrapper = exports.CellValue = exports.CellText = void 0;
var _react = _interopRequireDefault(require("react"));
var _Stack = _interopRequireDefault(require("@gogame/ui/Stack"));
var _intlTs = require("@gogame/intl-ts");
var _Tooltip = _interopRequireDefault(require("@gogame/ui/Tooltip"));
var _styles = require("@gogame/ui/styles");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["lineClamp", "color"],
  _excluded2 = ["editable"],
  _excluded3 = ["align"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var PercentValue = (0, _styles.styled)(function (_ref) {
  var value = _ref.value,
    className = _ref.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: className,
    "data-cy": _constants.dataCyPercentValue,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_intlTs.NumberValueFormatter.Percent, {
      value: value,
      precision: 0
    })
  });
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 10px;\n  position: relative;\n  top: -4px;\n  width: 26px;\n"])));
var CellText = exports.CellText = (0, _styles.styled)(/*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _ = _ref2.lineClamp,
    __ = _ref2.color,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
}))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  -webkit-line-clamp: ", ";\n  white-space: normal;\n  -webkit-box-orient: vertical;\n  word-break: break-word;\n  display: -webkit-box;\n  overflow: hidden;\n  color: ", ";\n"])), function (_ref3) {
  var _ref3$lineClamp = _ref3.lineClamp,
    lineClamp = _ref3$lineClamp === void 0 ? 1 : _ref3$lineClamp;
  return lineClamp;
}, function (_ref4) {
  var color = _ref4.color,
    theme = _ref4.theme;
  return color ? theme.palette[color].main : 'inherit';
});
var CellValue = exports.CellValue = (0, _styles.styled)(function (_ref5) {
  var icon = _ref5.icon,
    value = _ref5.value,
    color = _ref5.color,
    __ = _ref5.dotted,
    lineClamp = _ref5.lineClamp,
    editable = _ref5.editable,
    className = _ref5.className,
    percentValue = _ref5.percentValue,
    _ref5$placeholder = _ref5.placeholder,
    placeholder = _ref5$placeholder === void 0 ? '-' : _ref5$placeholder,
    _ref5$editingPlacehol = _ref5.editingPlaceholder,
    editingPlaceholder = _ref5$editingPlacehol === void 0 ? 'N/A' : _ref5$editingPlacehol,
    tooltip = _ref5.tooltip,
    dataCy = _ref5.dataCy,
    as = _ref5.as,
    _ref5$disableText = _ref5.disableText,
    disableText = _ref5$disableText === void 0 ? false : _ref5$disableText,
    _ref5$align = _ref5.align,
    align = _ref5$align === void 0 ? 'right' : _ref5$align;
  var content = value == null || (value === null || value === void 0 ? void 0 : value.length) === 0 ? editable ? editingPlaceholder : placeholder : value;
  if (!disableText) {
    content = /*#__PURE__*/(0, _jsxRuntime.jsx)(CellText, {
      lineClamp: lineClamp,
      color: color,
      as: as,
      children: content
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    spacing: 0.5,
    direction: 'row',
    alignItems: 'center',
    className: className,
    "data-title": tooltip,
    "data-cy": dataCy,
    children: [align === 'right' ? icon : null, tooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
      title: tooltip,
      extremelyLongTitle: tooltip.length > 2000,
      children: content
    }) : content, percentValue !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(PercentValue, {
      value: percentValue
    }), align === 'left' ? icon : null]
  });
}, {
  name: 'GgCellValue'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  border-bottom: ", ";\n  margin-top: ", ";\n  max-width: 100%;\n"])), function (_ref6) {
  var dotted = _ref6.dotted;
  return dotted ? '1.5px dotted #B0B0B0' : 'none';
}, function (_ref7) {
  var mt = _ref7.mt;
  return mt;
});
var CellWrapper = exports.CellWrapper = (0, _styles.styled)(function (_ref8) {
  var _ = _ref8.editable,
    props = _objectWithoutProperties(_ref8, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, props));
}, {
  name: 'GgCellWrapper'
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  line-height: normal;\n  ", ";\n  ", ";\n"])), function (_ref9) {
  var editable = _ref9.editable;
  return "cursor:".concat(editable ? 'pointer' : 'initial');
}, function (_ref0) {
  var editable = _ref0.editable;
  return "text-decoration:".concat(editable ? 'underline' : 'none');
});
var ValueWrapper = exports.ValueWrapper = (0, _styles.styled)(function (_ref1) {
  var align = _ref1.align,
    props = _objectWithoutProperties(_ref1, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, props));
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: ", ";\n  justify-content: center;\n  width: inherit;\n  height: inherit;\n  text-align: ", ";\n"])), function (_ref10) {
  var align = _ref10.align;
  return align === 'right' ? 'end' : align === 'left' ? 'start' : align;
}, function (_ref11) {
  var align = _ref11.align;
  return align;
});
var ListCellWrapper = exports.ListCellWrapper = (0, _styles.styled)(function (_ref12) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref12), _ref12));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, props));
}, {
  name: 'GgListCellWrapper'
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  line-height: normal;\n  ", ";\n"])), function (_ref13) {
  var align = _ref13.align;
  return "justify-content:".concat(align === 'right' ? 'flex-end' : 'flex-start');
});